// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'

/**
 * Spec 20261015-160924 AC-3: GET /auth/me/permissions. The caller's codes in the ERP tree (`../rbac/erp-tree.ts`),
 * flat and in the tree's order, and nothing else: no ids, no scopes, no other person.
 */
export const mePermissionsResponseSchema = z
    .object({ permissions: z.array(z.string()) })
    .strict()
export type MePermissionsResponse = z.infer<typeof mePermissionsResponseSchema>
